import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/apiClient";
import { ExpertCard } from "./ExpertCard";
import { UserCheck } from "lucide-react";
import { useT } from "../lib/i18n";

export const HumanReviewCTA = ({ sessionId }) => {
  const { t } = useT();
  const [experts, setExperts] = useState(null);
  const [labels, setLabels] = useState({});

  useEffect(() => {
    Promise.all([
      api.get(`/sessions/${sessionId}/recommended-experts`),
      api.get("/consultants/taxonomies"),
    ])
      .then(([e, tx]) => { setExperts(e.data.experts); setLabels(tx.data.expertise_labels); })
      .catch(() => setExperts([]));
  }, [sessionId]);

  if (!experts || experts.length === 0) return null;

  return (
    <div data-testid="human-review-cta" className="max-w-4xl mx-auto mt-8 no-print">
      <div className="bg-[#0B1B3D] rounded-xl p-8 text-white">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-[#0EA5E9] grid place-items-center"><UserCheck className="w-5 h-5" /></div>
          <div>
            <h2 className="font-display font-extrabold text-xl">{t("Get a Human Expert Review")}</h2>
            <p className="text-sm text-white/70 mt-0.5">{t("Add an independent human perspective to challenge the assumptions, risks and recommendations generated through the Konzenzo analysis.")}</p>
          </div>
        </div>
      </div>
      <div className="grid md:grid-cols-3 gap-4 mt-4" data-testid="recommended-experts">
        {experts.map((e) => <ExpertCard key={e.consultant_id} expert={e} labels={labels} />)}
      </div>
      <div className="flex items-center justify-center gap-6 mt-4">
        <Link data-testid="browse-all-experts" to="/marketplace" className="text-sm font-bold text-[#0EA5E9] hover:text-[#0B1B3D]">{t("Browse All Experts")} →</Link>
      </div>
    </div>
  );
};
